














import Component from 'vue-class-component';
import {VModel} from 'vue-property-decorator';
import {CustomerFormModel} from '@/context/customer/model/CustomerFormModel';
import Vue from 'vue';
import TextField from '@/general/component/TextField.vue';

import {AnomalyRemovalFormModel} from "@/context/calculation/model/AnomalyRemovalFormModel";
import {UploadFormModel} from "@/context/remote_configuration/model/UploadFormModel";
import DataLoggerIdentifierAutocomplete
  from "@/context/remote_configuration/components/DataLoggerIdentifierAutocomplete.vue";

@Component({
  components: {DataLoggerIdentifierAutocomplete, TextField}
})
export default class RemoteConfigurationUploadFormTemplate extends Vue {
  @VModel() model!: UploadFormModel;
  valid: boolean = true;

  get rules(): Record<string, unknown> {
    return {};
  }

  /**
   *   private String name;
   private String street;
   private String city;
   private String country;
   private Boolean active;
   */
}
